import {
  CREATE_CUSTOMFIELD_START,
  CREATE_CUSTOMFIELD_ERROR,
  CREATE_CUSTOMFIELD_SUCCESS,
  CREATE_CUSTOMFIELD_RESET,
  GETLEADS_CUSTOMFIELD_START,
  GETLEADS_CUSTOMFIELD_SUCCESS,
  GETLEADS_CUSTOMFIELD_ERROR,
  GETLEADS_CUSTOMFIELD_RESET,
  UPDATE_CUSTOMFIELD_START,
  UPDATE_CUSTOMFIELD_SUCCESS,
  UPDATE_CUSTOMFIELD_ERROR,
  UPDATE_CUSTOMFIELD_RESET,
  GETCUST_CUSTOMFIELD_START,
  GETCUST_CUSTOMFIELD_SUCCESS,
  GETCUST_CUSTOMFIELD_ERROR,
  GETCUST_CUSTOMFIELD_RESET,
} from "./ActionTypes"

export const createCustomFieldStart = payload => {
  return {
    type: CREATE_CUSTOMFIELD_START,
    payload,
  }
}

export const createCustomFieldError = payload => {
  return {
    type: CREATE_CUSTOMFIELD_ERROR,
    payload,
  }
}

export const createCustomFieldSuccess = payload => {
  return {
    type: CREATE_CUSTOMFIELD_SUCCESS,
    payload,
  }
}
export const createCustomFieldReset = () => {
  return {
    type: CREATE_CUSTOMFIELD_RESET,
  }
}
export const updateCustomFieldStart = payload => {
  return {
    type: UPDATE_CUSTOMFIELD_START,
    payload,
  }
}

export const updateCustomFieldSuccess = payload => {
  return {
    type: UPDATE_CUSTOMFIELD_SUCCESS,
    payload,
  }
}

export const updateCustomFieldError = payload => {
  return {
    type: UPDATE_CUSTOMFIELD_ERROR,
    payload,
  }
}

export const updateCustomFieldReset = () => {
  return {
    type: UPDATE_CUSTOMFIELD_RESET,
  }
}

export const getLeadsCustomFieldStart = () => {
  return {
    type: GETLEADS_CUSTOMFIELD_START,
  }
}

export const getLeadsCustomFieldSuccess = payload => {
  return {
    type: GETLEADS_CUSTOMFIELD_SUCCESS,
    payload,
  }
}

export const getLeadsCustomFieldError = payload => {
  return {
    type: GETLEADS_CUSTOMFIELD_ERROR,
    payload,
  }
}

export const getLeadsCustomFieldReset = () => {
  return {
    type: GETLEADS_CUSTOMFIELD_RESET,
  }
}

//GET Customer custom fields

export const getCustomerCustomFieldStart = () => {
  return {
    type: GETCUST_CUSTOMFIELD_START,
  }
}

export const getCustomerCustomFieldSuccess = payload => {
  return {
    type: GETCUST_CUSTOMFIELD_SUCCESS,
    payload,
  }
}

export const getCustomerCustomFieldError = payload => {
  return {
    type: GETCUST_CUSTOMFIELD_ERROR,
    payload,
  }
}

export const getCustomerCustomFieldReset = () => {
  return {
    type: GETCUST_CUSTOMFIELD_RESET,
  }
}
